var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 45,
    viewBox: "0 0 37 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.025 4.203 18.074 0 36.54 4.203v20.01a16.748 16.748 0 0 1-7.5 13.958l-9.912 6.568a1.558 1.558 0 0 1-1.716 0L7.5 38.17C2.82 35.07 0 29.826 0 24.214V4.204h.025Z",
    fill: "#332FF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 22,
    width: 6,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.712 30.232s-1.401-4.057-.832-6.721c.285-1.338-2.918-1.141-3.432.279-.91 2.518-.713 6.44-.713 6.44l4.977.002Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.712 30.232s-1.401-4.057-.832-6.721c.285-1.338-2.918-1.141-3.432.279-.91 2.518-.713 6.44-.713 6.44l4.977.002Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.712 30.232s-1.401-4.057-.832-6.721c.285-1.338-2.918-1.141-3.432.279-.91 2.518-.713 6.44-.713 6.44l4.977.002Z",
    fill: "url(#b)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.354 20.623c.72.511 1.029 1.165 1.138 1.752.107.574.097 1.094-.21 1.925-.636 1.478-1.661 1.892-3.006 2.047-.653.075-1.371.113-2.601.113h-1.732l2.226-4.221s.021.032.364 0c.547-.052.987-.386 1.3-.982.068-.129.372-.809.579-1.277 1.058.14 1.694.466 1.942.643Z",
    fill: "#000",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 8,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.617 19.293a2.71 2.71 0 0 1 1.138 1.752c.107.574.097 1.094-.21 1.925-.636 1.478-1.661 1.893-3.006 2.047-.653.075-1.371.113-2.601.113h-1.469l2.221-4.212c-.178.015.005-.01.005-.01l-.005.01.106-.01c.547-.05.987-.385 1.3-.982.068-.128.372-.808.579-1.277 1.058.141 1.694.467 1.942.644Z",
    fill: "#58FDC0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.617 19.293a2.71 2.71 0 0 1 1.138 1.752c.107.574.097 1.094-.21 1.925-.636 1.478-1.661 1.893-3.006 2.047-.653.075-1.371.113-2.601.113h-1.469l2.221-4.212c-.178.015.005-.01.005-.01l-.005.01.106-.01c.547-.05.987-.385 1.3-.982.068-.128.372-.808.579-1.277 1.058.141 1.694.467 1.942.644Z",
    fill: "#58FDC0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.335 22.498c.074.815-1.097 1.124-2.142 1.425 0 0 .594-1.502 0-2.497-.594-.996-2.454-1.183-3.374-1.315-.762-.109-1.314-.48-1.314-.48.814-1.773.917-2.009.917-2.009s.006-.008.009-.008c.565.09.743.096 1.491.29.863.22 1.631.53 2.27.976.34.235.686.57 1.002.936.212.244.473.642.61.92 0 0 .448.854.53 1.762Z",
    fill: "#000"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 7,
    width: 19,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.985 30.23H9.2L25.63 7.886h1.446L14.984 30.231Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.985 30.23H9.2L25.63 7.886h1.446L14.984 30.231Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.24,
    d: "M15.511 15.51h6.309v4.469h-6.309z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M19.191 12.881H25.5v4.206h-6.309z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.735 18.222c1.85-.017 2.907.499 3.254.742a2.89 2.89 0 0 1 1.212 1.85c.023.48 0 .611-.108 1.006 0 0 1.896-2.773 1.493-5.493a4.018 4.018 0 0 0-.584-1.55c-.968-1.458-3.393-1.554-3.393-1.554l-13.357-.091c-.134.38-.14.8-.125 1.171a4.66 4.66 0 0 0 .5 1.922c1.026 1.962 3.78 1.997 3.78 1.997h7.328Z",
    fill: "#58FDC0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 15.943,
    y: 17.98,
    width: 11.61,
    height: 10.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_201_203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 19.505,
    y: 16.614,
    width: 8.833,
    height: 8.309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_201_203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 13.511,
    y: 13.51,
    width: 10.309,
    height: 8.469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_201_203"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 17.191,
    y: 10.881,
    width: 10.309,
    height: 8.206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_201_203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.074,
    y1: 24.32,
    x2: 22.343,
    y2: 28.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.17a566e022c7bf9d2dee11740f4f6b59.svg";
export { ForwardRef as ReactComponent };